const TestimonialsSection = () => {
  // Novos depoimentos específicos
  const featuredTestimonials = [
    {
      name: "João Silva",
      role: "Infoprodutor",
      content: "Finalmente parei de travar. Em 2 semanas já estava com funil, anúncios e conteúdo rodando.",
      avatar: "👨‍💼",
      rating: 5,
    },
    {
      name: "Letícia Costa",
      role: "Afiliada",
      content: "Economizei 15 horas por semana só com as planilhas.",
      avatar: "👩‍💻",
      rating: 5,
    },
    {
      name: "Pedro Almeida",
      role: "Iniciante",
      content: "Melhor R$14,90 que já investi.",
      avatar: "🧑‍🎓",
      rating: 5,
    },
  ];

  const stats = [
    { metric: "2.000+", label: "Usuários Ativos" },
    { metric: "+150%", label: "Aumento em Vendas" },
    { metric: "4.8/5", label: "Avaliação Média" },
  ];

  return (
    <section className="py-20 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-foreground mb-6">
            📈 Resultados e Prova Social
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Veja o que nossos membros estão conseguindo
          </p>
        </div>

        {/* Statistics */}
        <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto mb-16">
          {stats.map((stat, index) => (
            <div key={index} className="bg-card p-6 rounded-xl shadow-medium text-center">
              <div className="text-4xl font-bold text-primary mb-2">
                {stat.metric}
              </div>
              <div className="text-muted-foreground">
                {stat.label}
              </div>
            </div>
          ))}
        </div>

        {/* Featured Testimonials */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {featuredTestimonials.map((testimonial, index) => (
            <div key={index} className="bg-card p-6 rounded-lg shadow-medium">
              <div className="flex items-center gap-4 mb-4">
                <div className="text-4xl">{testimonial.avatar}</div>
                <div>
                  <h3 className="font-bold text-foreground">{testimonial.name}</h3>
                  <p className="text-sm text-muted-foreground">{testimonial.role}</p>
                </div>
              </div>
              
              <div className="flex gap-1 mb-3">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <span key={i} className="text-yellow-500">⭐</span>
                ))}
              </div>
              
              <p className="text-muted-foreground italic">"{testimonial.content}"</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
